import { useMemo, useState } from "react";
import { Box, Typography, Grid, Button } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { useSettings } from "../../../context/SettingsContext";
import BookingModal from "./BookingModal";
import BookingCard from "./BookingCard";
import PageTitle from "../../../components/PageTitle";

const DEFAULT_HOURS = { start: 9, end: 17 };

export default function PipelineBookingSystems() {
  const { pipeline_features, updatePipelineFeatures } = useSettings();
  const [active, setActive] = useState(null);

  const bookings = useMemo(
    () => (pipeline_features || []).filter((f) => f.meta?.type),
    [pipeline_features]
  );

  const saveBooking = async (payload) => {
    const current = pipeline_features || [];

    const isEdit = Boolean(payload.key);

    const type = isEdit
      ? payload.meta.type
      : payload.meta.type || payload.label.toLowerCase().replace(/\s+/g, "_");

    const key = isEdit ? payload.key : `bookings:${type}`;

    const normalized = {
      ...payload,
      key,
      meta: {
        ...payload.meta,
        type,
      },
    };

    const final = isEdit
      ? current.map((f) =>
          f.key === payload.key
            ? {
                ...f,
                label: normalized.label,
                enabled: normalized.enabled,
                order: normalized.order,
                position: normalized.position,
                meta: {
                  ...f.meta,
                  workingHours: normalized.meta.workingHours,
                  durations: normalized.meta.durations,
                },
              }
            : f
        )
      : [...current, normalized];

    await updatePipelineFeatures(final);
    setActive(null);
  };

  console.log(bookings);

  const deleteBooking = async (key) => {
    console.log(key);

    const final = (pipeline_features || []).filter((f) => f.key !== key);
    await updatePipelineFeatures(final);
  };

  return (
    <Box>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        mb={2}
      >
        <PageTitle parts={["Settings", "Pipelines", "Bookings"]} />

        <Button
          startIcon={<AddIcon />}
          variant="contained"
          onClick={() =>
            setActive({
              label: "",
              enabled: true,
              position: "right",
              meta: {
                type: "",
                workingHours: DEFAULT_HOURS,
                durations: [60],
              },
            })
          }
        >
          Add Booking
        </Button>
      </Box>

      <Grid container spacing={2}>
        {bookings.map((booking) => (
          <Grid item xs={12} md={6} key={booking.key}>
            <BookingCard
              booking={booking}
              onEdit={() =>
                setActive({
                  ...booking,
                  _originalType: booking.meta.type,
                })
              }
              onDelete={() => deleteBooking(booking.key)}
            />
          </Grid>
        ))}
      </Grid>

      {active && (
        <BookingModal
          booking={active}
          onClose={() => setActive(null)}
          onSave={saveBooking}
        />
      )}
    </Box>
  );
}
